import { ComponentType } from 'react'

import { safeLazy } from './saleLazy'

export const namedSafeLazy = <T extends Record<string, any>, U extends keyof T>(
  loader: (x?: string) => Promise<T>,
) =>
  new Proxy({} as unknown as T, {
    get: (_, componentName: string | symbol) => {
      if (typeof componentName === 'string') {
        return safeLazy(
          () =>
            loader(componentName).then(x => ({
              default: x[componentName as U] as ComponentType<any>,
            })) as Promise<{ default: ComponentType<any> }>,
        )
      }
    },
  })
